import { useCallback, useState, useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import { Option } from '../../interface/Option';
import { Activity, ActivityActivity } from '../../interface/Activity';
import { ActivityAxiosInstance } from "../../Network/ActivityAxiosInstance";

const ListOfCustomActivityGroups = ({ onChange, clear, defaultValue, reloadTrigger }: any) => {
  const [cacheOptions, setCacheOptions] = useState<{ [key: string]: Option[] }>({});
  const [selectedOptions, setSelectedOptions] = useState<Option[]>(defaultValue || []); // Set the default value if it exists
  const [inputKey, setInputKey] = useState(0); // To reset AsyncSelect when needed

  const loadOptions = useCallback(
    async (inputValue: string): Promise<Option[]> => {
      try {
        const response = await ActivityAxiosInstance.put<Activity>(`getActivity/`);
        const data: ActivityActivity[] = response.data.activities;

        const options: Option[] = data.map((item: ActivityActivity) => ({
          value: item.id,
          label: item.name,
        }));

        // search
        const filteredOptions = options.filter((option: Option) =>
          option.label.toLowerCase().includes(inputValue.toLowerCase())
        );

        setCacheOptions((prevCache) => ({
          ...prevCache,
          [inputValue]: filteredOptions,
        }));

        return filteredOptions;
      } catch (error) {
        console.error("Error loading options:", error);
        return [];
      }
    },
    []
  );

  const handleChange = (newValue: any) => {
    setSelectedOptions(newValue || []); // Update the selected options
    onChange(newValue || []); // Send changes out
  };

  // clear
  useEffect(() => {
    if (clear) {
      setSelectedOptions([]); 
      setCacheOptions({}); 
      setInputKey((prevKey) => prevKey + 1); // Reset AsyncSelect
    }
  }, [clear]);

// Set the default value when modifying
  useEffect(() => {
    if (defaultValue) {
      setSelectedOptions(defaultValue); 
      setCacheOptions({}); 
      setInputKey((prevKey) => prevKey + 1); 
    }
  }, [defaultValue]);

// Reload options when changed after adding or deleting
  useEffect(() => {
    if (reloadTrigger) {
      setCacheOptions({});
      setInputKey((prevKey) => prevKey + 1); 
    }
  }, [reloadTrigger]); // Called when `reloadTrigger` is changed

  return (
    <AsyncSelect
      key={inputKey} // To update the component when the key changes
      cacheOptions
      className="controlWidth mb-3"
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      loadOptions={loadOptions}
      onChange={handleChange}
      defaultOptions
      value={selectedOptions} // Set the chosen value
      placeholder="Type characters to search..."
    />
  );
};

export default ListOfCustomActivityGroups;





